<template>
    <div>
        <a @click="closeModules" style="cursor: pointer;">[Fechar todos]</a>&nbsp;
        <a @click="openModules" style="cursor: pointer;">[Abrir Ativos]</a>

        <br>
        <br>
        <div @click="setModulesData">CHECK</div>
        <draggable
            v-model="modules"
            handle=".mh_handler"
            class="list-group">

            <div
                class="list-group-item mh_wrapper"
                v-for="(item, index) in modules"
                :key="index"
                :class="{ active: item.open }">

                <div class="mh_header" @click="toggle(item.module_name)">
                    <i class="material-icons mh_left mh_handler">
                        reorder
                    </i>
                    <div v-if="item.active" class="mh_title"><strong>{{item.title}}</strong></div>
                    <div v-else class="mh_title">{{item.title}}</div>
                    <i class="material-icons mh_right">
                        arrow_drop_down
                    </i>
                </div>

                <div class="mh_content">

                    <v-switch
                        v-model="item.active"
                        label="Mostrar"
                        :disabled="permission.write?null:true">
                    </v-switch>

                    <component
                        v-if="item.module"
                        v-model="item.content"
                        :disabled="permission.write?null:true"
                        :is="item.module"
                        :ref="item.module">
                    </component>

                </div>

                <div class="mh_footer" @click="toggle(item.module_name)">
                    <i class="material-icons">
                        arrow_drop_up
                    </i>
                </div>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import permission from '../../../mixins/permissions';

import InfoBlock from '../../../components/Main/Content/showModule/infoBlock';
import InfoTheysay from '../../../components/Main/Content/showModule/infoTheysay';
import InfoVant from '../../../components/Main/Content/showModule/infoVant';
import InfoWall from '../../../components/Main/Content/showModule/infoWall';
import InfoBig from '../../../components/Main/Content/showModule/infoBigtitle';
import InfoContact from '../../../components/Main/Content/showModule/infoContact';
import InfoAux from '../../../components/Main/Content/showModule/infoAux';
import InfoRight from '../../../components/Main/Content/showModule/infoRight';
import InfoCourses from '../../../components/Main/Content/showModule/infoCourses';
import InfoForm from '../../../components/Main/Content/showModule/infoForm';
import InfoSocial from '../../../components/Main/Content/showModule/infoSocial';


export default {
    mixins: [ permission ],
    components: {
        draggable,
        InfoBlock,
        InfoTheysay,
        InfoVant,
        InfoWall,
        InfoBig,
        InfoContact,
        InfoAux,
        InfoRight,
        InfoCourses,
        InfoForm,
        InfoSocial,
    },
    data()
    {
        return {
            permission: false,
            keyer: 0,
            modules: []
        }
    },
    computed: {
        storeModules() {
            const value = this.$store.state.page.modules;
            if( value )
            {
                if( value.indexOf('[') !== -1 )
                {
                    return JSON.parse( value )
                }
            }
            return [];
        }
    },
    watch: {
        storeModules()
        {
            this.modules = this.storeModules.map( item => {
                item['open'] = item.active;
                return item;
            });

            if( this.keyer === 0 ) {
                this.keyer++;
                this.openModules();
                this.checkModules();
            }
        }
    },
    created()
    {
        this.permission = this.getUserPagePermission('pages');
		if( this.permission.read == false ) {
			this.$router.push('/');
        }
    },
    methods: {
        setModulesData() {
            this.modules.forEach( item => {
                if( item.module )
                {
                    item.content = this.$refs[item.module][0].getModuleData();
                }
            });
            this.$store.commit( 'set_pagedata', {
                field: 'modules',
                data: JSON.stringify( this.modules )
            });
        },
        openModules: function()
        {
            this.modules.forEach( item => {
                if( item.active ) item.open = true;
            });
        },
        closeModules: function()
        {
            this.modules.forEach( item => {
                item.open = false;
            });
        },
        toggle( module_name )
        {
            this.modules.forEach( item => {
                if( item.module_name == module_name ) item.open = !item.open;
            });
        },
        checkModules()
        {
            if( !this.modules.length )
            {
                this.modules = [
                    {
                        module: 'InfoBlock',
                        module_name: 'show_infoblocks',
                        title: "Blocos Informativos",
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: 'InfoTheysay',
                        module_name: 'show_theysay',
                        title: "O que as pessoas dizem",
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: 'InfoVant',
                        module_name: 'show_advantages',
                        title: "Vantagens",
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: 'InfoWall',
                        module_name: 'show_imageswall',
                        title: "Divisória de imagens",
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: 'InfoBig',
                        module_name: 'show_bigtitle',
                        title: 'Título grande',
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: 'InfoContact',
                        module_name: 'show_contact',
                        title: 'Contato',
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: 'InfoAux',
                        module_name: 'show_auxcontent',
                        title: 'Conteúdo auxiliar',
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: 'InfoRight',
                        module_name: 'show_rightcontent',
                        title: 'Conteúdo à direita',
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: 'InfoCourses',
                        module_name: 'show_courses',
                        title: 'Cursos',
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: 'InfoForm',
                        module_name: 'show_form',
                        title: 'Formulário',
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: 'InfoSocial',
                        module_name: 'show_social',
                        title: 'Redes Sociais',
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: false,
                        module_name: 'show_blog',
                        title: 'Blog posts',
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: false,
                        module_name: 'show_news',
                        title: 'Newsletter',
                        content: '',
                        active: false,
                        open: false
                    },
                    {
                        module: false,
                        module_name: 'show_events',
                        title: 'Próximos Eventos',
                        content: '',
                        active: false,
                        open: false
                    }
                ];
            }
        }
    }
}
</script>